<div [formGroup]="parent" class="mb-30 margin-top-30"
[ngClass]="pageName === 'activities-of-daily-living' || pageName === 'dependant-activities-of-daily-living' ? 
     'mb-30 margin-top-0 wd-100' : (parent.get(controlName).touched
                        &&
                    parent.get(controlName).errors ? 'mb-30 margin-top-30 flex-column' : 'mb-30 margin-top-30 flex-row')">
    <div class="form-field">
        <div class="question-style normal-ques-style mb-30" role="dropdown" *ngIf="question.questionText">
            <div *ngIf="pageName === 'activities-of-daily-living' || pageName === 'dependant-activities-of-daily-living'; then customTemplate else defaultTemplate">
                
            </div>
            <ng-template #customTemplate>
              
                <div [ngClass]="controlName == 'ADQ004' || controlName == 'ADQ009' ? 'mar-bottom-30 mar-top-30':'margin-top-bottom-30'"
                    [id]="'lbl-'+pageName+'-'+controlName" [attr.for]="controlName">{{label}}</div>
                
            </ng-template>
            
            <ng-template #defaultTemplate>
                <div class="margin-bottom-30" [id]="'lbl-'+pageName+'-'+controlName" [attr.for]="controlName">{{label}}</div>
            </ng-template>

            

            <span class="info-icon d-view"
                *ngIf="question.helpText">
                <app-tool-tip-notification [childId]="'dropdownStandard'" [tooltipData]="initializeToolTipDateComp(question)">
                </app-tool-tip-notification>
            </span>

            <span class="info-icon mt-view"
                *ngIf="question.helpText">
                <app-tool-tip-notification [childId]="'dropdownStandard'" [tooltipData]="initializeToolTipDateComp(question)" 
                (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver()">
                </app-tool-tip-notification>
            </span>

            <span *ngIf="!question.helpText && router.url === 'home/medical-condition-questionnaire'" class="info-icon mt-view d-none"  > 
                <!-- medical-condition-questionnaire -->
                <app-tool-tip-notification [childId]="'dropdownStandard'" [tooltipData]="initializeToolTipDateComp(question)"
                    (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver()">
                </app-tool-tip-notification>
            </span>

        </div>

        <div  
         [ngClass]="controlName == 'ADQ004' || controlName == 'ADQ009' ? 'form-field-select wd-30 mar-topbottom-3':'form-field-select wd-30'">
            <select [formControlName]="controlName" id="{{domId}}" class="form-control" aria-required="true" [attr.aria-label]="label?label:controlName"
                [(ngModel)]="selectedOption" (change)="onChangeOfDropdown($event)" [attr.aria-invalid]="(parent.get(controlName).touched && parent.get(controlName).errors) ? true : false"
                [formControlName]="controlName">
                <option value="">Please select </option>
                <option *ngFor="let value of dropdownList" [ngValue]="value">
                    {{value}}</option>
            </select>
            <i class="icon icon-chevron-down" aria-hidden="true"></i>
        </div>
    </div>
    <div class="top-10 form-validation-error" *ngIf="parent.get(controlName).touched
                        &&
                    parent.get(controlName).errors">
        <i class="icon icon-error" aria-hidden="true"></i>
        <p [id]="pageName+'-'+controlName +'-error'" *ngIf="parent.get(controlName).errors.required" aria-hidden="false" role="error"
            aria-live="polite">Please make a selection</p>
    </div>
</div>